const BASE_URL = `/api-dprot`;
export const GET_DIGITAL_PROTOCOL_LANDING_INFO_URL = `${BASE_URL}/get_dprotocol_details`;
export const UPDATE_DIGITAL_PROTOCOL_LANDING_TITLE_URL = `${BASE_URL}/update_dprotocol_trial_alias`;
export const COHORTS_URL = `${BASE_URL}/cohorts`;
export const COHORTS_NOT_LINKED_URL = `${BASE_URL}/cohorts_no_linked`;
export const SOA_LIST_URL = `${BASE_URL}/list_all_table_cohorts`;
export const GET_DIGITAL_PROTOCOL_SOA = `${BASE_URL}/get_dprot_soa`;
export const FINALIZE_SOA_URL = `${BASE_URL}/finalize_dprot_soa`;

export const UPDATE_ARM_COHORT_IN_SOA_LIST_URL = `${BASE_URL}/arms_map`;
export const UPDATE_UNIT_IN_SOA_LIST_URL = `${BASE_URL}/update_visit_unit`;
export const GET_UNIT_IN_SOA_LIST_URL = `${BASE_URL}/get_visit_unit`;
export const DEL_SOA_TABLE_LIST_URL = `${BASE_URL}/delete_soa_table`;
export const ADD_SOA_TABLE_LIST_URL = `${BASE_URL}/add_soa_table`;

export const GET_SOA_ACTIVITY_LIBRARY_URL = `${BASE_URL}/get_dprot_soa_library`;

export const GET_FOOTNOTE_TYPE_LIST_URL = `${BASE_URL}/get_footnote_type`;
export const SAVE_SOA_ACTIVITY_URL = `${BASE_URL}/save_dprot_soa`;
export const GET_FOOTNOTE_DROPDOWN_OPTIONS_URL = `${BASE_URL}/get_footnote_dropdown`;
export const GET_FOOTNOTE_DATA_URL = `${BASE_URL}/get_footnote_summary`;
export const FOOTNOTE_DETAIL_URL = `${BASE_URL}/footnote_details`;
export const UPDATE_SOA_TABLE_NAME_URL = `${BASE_URL}/update_table_name`;
export const EXPORT_AS_EXCEL_URL = `${BASE_URL}/dprot_export`;

export const ARM_COHORT_URL = `${BASE_URL}/arms`;

export const ENDPOINT_URL = `${BASE_URL}/drotocol_endpoint`;
export const GET_ENDPOINT_LIB = `${BASE_URL}/get_lib_endpoint`;
export const GET_STATS_LIB = `${BASE_URL}/get_stats_tests_lib`;
export const GET_ANALYSIS_SET_LIST = `${BASE_URL}/get_analysis_sets_lib`;
export const FINALIZE_STATUS_URL = `${BASE_URL}/section_status`;

export const STUDY_POPULATION_URL = `${BASE_URL}/population`
export const STUDY_POPULATION_GET_URL = `${BASE_URL}/get_population_details`
